export enum RuleGroupNames {
  Single = 'Single',
  Any = 'Any',
  All = 'All',
}

interface SegmentsRuleOperation {
  operand: number;
  type: string;
}

interface SegmentsGroupsRules {
  not: boolean;
  object: RuleGroupNames;
  operation?: SegmentsRuleOperation;
  type: string;
  userSeenRuleType: string;
}

interface SegmentsGroupsDefinition {
  groups: SegmentsGroupsRules;
  object: string;
}

export interface SegmentsDefinition {
  definition: SegmentsGroupsDefinition;
  description?: string;
  id: string;
  lastModifiedAt?: string;
  name: string;
  ownerId: number;
  archivedAt?: string;
}
